export type QueryParams = string | number | QueryDateRange;

export interface QueryDateRange {
  type: 'date-range';
  from: Date | null;
  to: Date | null;
}

export function isDateRange(input: QueryParams): input is QueryDateRange {
  return (input as QueryDateRange)?.type === 'date-range';
}
